import queryString from 'query-string';
import { css } from 'styled-components';
/**
 * Create an image URL for ImageProcessor
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image || !image.src) {
        return '';
    }
    /**
     * Remove any query param string to ensure paramsString is applied correctly and
     * there are no double definitions (setting a param twice prevents any tranformations)
     */
    const imageSource = image.src.split('?')[0];
    const params = {
        rxy: image.focalPoint ? `${image.focalPoint.left},${image.focalPoint.top}` : undefined,
        // Define default quality as 95 to ensure some reduction in size for all but the smallest images
        quality: imageParams.width && imageParams.width > 400 ? 95 : undefined,
        ...imageParams,
    };
    const paramsString = queryString.stringify(params);
    return `${imageSource}${paramsString ? `?${queryString.stringify(params)}` : ''}`;
}
export function srcSet(image, imageParams) {
    if (!image || !image.src) {
        return '';
    }
    const pixelDensities = [1, 1.5, 2, 2.5, 3];
    return pixelDensities
        .map((pd) => `${imageUrl(image, {
        ...imageParams,
        ...(imageParams.width ? { width: imageParams.width * pd } : {}),
        ...(imageParams.height ? { height: imageParams.height * pd } : {}),
    })} ${pd}x`)
        .join(',');
}
/**
 * Re-usable styles for image container where the
 * image needs to maintain it's aspect ratio
 *
 * @param width
 * @param height
 * @returns
 */
export function imageWrapperPreserveRatio(width, height) {
    if (!width && !height) {
        return null;
    }
    return css `
    position: relative;
    height: 0;
    overflow: hidden;
    overflow: clip;
    ${imageWrapperRatioPadding(width, height)};
  `;
}
/**
 * Calculates the percentage bottom padding
 * required to maintain a certain ratio.
 *
 * To be used in cases where the image ratio
 * changes based on viewport.
 *
 * @param width
 * @param height
 * @returns padding-bottom: {ratioPercentage}%
 */
export function imageWrapperRatioPadding(width, height) {
    if (!width && !height) {
        return '';
    }
    const ratioPercentage = ((height / width) * 100).toFixed(2);
    return `padding-bottom: ${ratioPercentage}%`;
}
/**
 * Re-usable styles for an image placed within
 * a container maintaining aspect ratio
 */
export const imageCoverContainer = (relative) => css `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  ${!relative && 'position: absolute; top: 0;left: 0;'}
`;
